import { useState } from "react"
import Project from "./Project"
import SingleChapter from "./SingleChapter"
import FullDocumentationView from "./FullDocumentationView"

const ProjectMain = () => {
  const [page, setPage] = useState('Project')
  const [selectedDoc, setSelectedDoc] = useState(null)
  const [selectedChapter, setSelectedChapter] = useState(null)

  return (
    <div>
      {page === 'Project' ? (
        <Project
          page={page}
          setPage={setPage}
          setSelectedDoc={setSelectedDoc}
          setSelectedChapter={setSelectedChapter}
        />
      ) : page === 'FullDoc' ? (
        <FullDocumentationView
          doc={selectedDoc}
          setPage={setPage}
          setSelectedChapter={setSelectedChapter}
        />
      ) : (
        <SingleChapter
          setPage={setPage}
          doc={selectedDoc}
          chapter={selectedChapter}
          onDocUpdate={setSelectedDoc}
        />
      )}
    </div>
  )
}

export default ProjectMain
